/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberCoupon {
  couponId?: number;
  couponName?: string;
  couponType?: number;
  couponUsageTypeId?: number;
  dateCreated?: Date;
  dateExpired?: Date;
  freeShipping?: number;
  freebieMessage?: string;
  glampoints?: number;
  inviterPersonid?: number;
  paymentId?: number;
  paymentLogId?: number;
  paymentMethod?: number;
  subscriberCouponId?: number;
  subscriberId?: number;
  subscriptionTypeId?: number;
  totalPrice?: number;
  value?: number;
}
